<div class="container py-3">
  <h2 class="mb-3">License</h2>

  <!-- Subsection: Current Purchased License(s) -->
  <div class="subsection mt-2">
    <div class="d-flex justify-content-between align-items-center mb-2 subheader">
      <h4 class="m-0 subsection-title">Current Active License(s)</h4>
    </div>
    <div class="table-responsive border rounded" *ngIf="displayItems.length > 0; else emptyState">
      <table class="table table-sm align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th>License name</th>
            <th>Valid through</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let it of displayItems">
            <td>{{ it.name }}</td>
            <td>{{ it.through | date:'yyyy-MM-dd' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #emptyState>
      <div class="text-muted" *ngIf="!loading">No active licenses.</div>
      <div class="text-muted" *ngIf="loading">Loading...</div>
    </ng-template>
  </div>

  <!-- Subsection: License Activation -->
  <div class="subsection mt-4">
    <div class="d-flex flex-column align-items-start mb-2 subheader">
      <h4 class="m-0 subsection-title">Activate New License
        <span class="material-icons ms-2" style="font-size:18px; cursor:pointer; vertical-align: middle;"
              matTooltip="When you purchase a product subscription from our online store, an activation key will be sent to you by email. You can copy and paste this key here to activate your product."
              (click)="openInfo('When you purchase a product subscription from our online store, an activation key will be sent to you by email. You can copy and paste this key here to activate your product.')">info</span>
      </h4>
      <span class="text-primary" style="font-weight: 400;">After activating a new license, please sign out and sign back in for the changes to take effect.</span>
    </div>
    <textarea
      class="form-control mb-2 activation-box"
      rows="4"
      [(ngModel)]="activationCode"
      (focus)="clearDefaultMessage()"
      ></textarea>
    <button class="btn btn-primary" [disabled]="isActivateDisabled" (click)="onActivate()">
      {{ activating ? 'Activating...' : 'Activate' }}
    </button>
  </div>
</div>


